import React from 'react';
import ReactDOM from 'react-dom/client';

import App from './App';

import 'animate.css';
import 'yet-another-react-lightbox/styles.css';
import 'yet-another-react-lightbox/plugins/captions.css';

import './index.css';

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
	<App />,
);
